import { useState, useEffect, useRef } from "react";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useNavigate } from "react-router-dom";
import nextbtn from "../../Assets/images/arrow-right.png";
import defaultProfile from "../../Assets/images/placeholder.png";
import {
  deleteRelationship,
  uploadFiles,
  fetchCategoriesAndTypes,
  uploadURL,
} from "../../Services/Realtionship";
import { acceptRequest, denyRequest } from "../../Services/Realtionship";
import { ReactComponent as CloseIcon } from "../../Assets/icon/close.svg";

import { useHeader } from "../../Providers/HeaderContextProvider";
import ContentLoader from "../../Pages/LoadingPage/ContentLoader";

const AcceptPendingRequest = ({
  request,
  onAccept,
  onReject,
  onBack,
  onUpdateContact,
  onDeleteContact,
  navigateBack,
  onClose,
}) => {
  const fileInputRef = useRef(null);
  const { profileContent, addProfileData } = useHeader();

  const initialFormData = {
    first_name: request?.firstName || "",
    last_name: request?.lastName || "",
    relationship_type:
      request?.relationshipType || request?.related_data?.relationship_type || "",
    relationship_length: (() => {
      const lengthVal =
        request?.related_data?.relationship_length || request?.relationshipLength || "";
      const birthYear = new Date(profileContent?.DOB || '').getFullYear();
      return lengthVal == birthYear ? "Since Birth" : lengthVal;
    })(),
    relationship_category:
      request?.relationshipCategory || request?.related_data?.relationship_category || "",
    relationship_status:
      request?.relationshipStatus || request?.related_data?.relationship_status || "",
    email: request?.email || null,
    nickname: request?.nickname || null,
    contact: request?.contact || null,
    profile_pic_url: request?.profilePic || null,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(
    initialFormData.profile_pic_url
  );
  const [selectedFile, setSelectedFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [relationTypes, setRelationTypes] = useState([]);
  const [relationLengths, setRelationLengths] = useState([]);
  const [relationStatuses, setRelationStatuses] = useState([]);
  const [isEditable, setIsEditable] = useState(true);
  const [error, setError] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [issending, setIssending] = useState(false);
  const [showYearPicker, setshowYearPicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const birthYear = new Date(profileContent?.DOB || '').getFullYear();
    const lengthVal = request?.related_data?.relationship_length || request?.relationshipLength || '';
    if (lengthVal && lengthVal != birthYear && lengthVal !== 'Since Birth') {
      setshowYearPicker(true);
    }
  }, [request, profileContent?.DOB]);



  const navigate = useNavigate();

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const categoriesData = await fetchCategoriesAndTypes();
        setCategories(Array.isArray(categoriesData) ? categoriesData : []);

        const lengthsData = await fetchCategoriesAndTypes("length");
        setRelationLengths(Array.isArray(lengthsData) ? lengthsData : []);

        const statusesData = await fetchCategoriesAndTypes("status");
        setRelationStatuses(Array.isArray(statusesData) ? statusesData : []);

        if (initialFormData.relationship_category) {
          const types = await fetchCategoriesAndTypes(
            initialFormData.relationship_category
          );
          setRelationTypes(Array.isArray(types) ? types : []);
        }

        if (request?.relation_status !== "pending") {
          setIsEditable(false);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    fetchInitialData();
  }, []);

  const isFormValid = () => {
    return (
      formData.relationship_category !== "" &&
      formData.relationship_type !== "" &&
      formData.relationship_status !== "" &&
      formData.relationship_category !== "Select Category" &&
      formData.relationship_type !== "Select Type" &&
      formData.relationship_status !== "Select Status"
    );
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;
    // Toggle YearPicker when selecting "Select Year"
    if (name === "relationship_length" && value === "Select Year") {
      setFormData((prev) => ({
        ...prev,
        relationship_length: "",
      }));
      setshowYearPicker(true);
      return;
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    if (name === "relationship_category") {
      try {
        const response = await fetchCategoriesAndTypes(value);
        if (Array.isArray(response)) {
          setRelationTypes(response);
          setFormData((prev) => ({
            ...prev,
            relationship_type: "",
          }));
        }
      } catch (error) {
        console.error("Error fetching relationship types:", error);
      }
    }
  };

  const onResetDate = () => {
    setFormData({ ...formData, relationship_length: "" });
    setshowYearPicker(false);
  };

  const handlePhoneChange = (value) => {
    const phoneNumber = parsePhoneNumberFromString(value);
    if (phoneNumber) {
      setFormData((prev) => ({
        ...prev,
        country_code: "+" + phoneNumber.countryCallingCode,
        contact: phoneNumber.nationalNumber,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        contact: null, // Set to null if there's no valid phone number
      }));
    }
  };

  const handleImageClick = () => {
    if (!isEditable) {
      fileInputRef.current?.click();
    }
  };

  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!validTypes.includes(file.type)) {
      setError("Invalid file type. Accepted types: JPEG, PNG, JPG");
      return;
    }

    const data = {
      image: file.name,
      image_type: file.type.split("/")[1],
    };

    try {
      setError(null);
      setUploading(true);
      const UrlResponse = await uploadURL(request.id, data);
      if (UrlResponse && UrlResponse.payload[0].image_url) {
        try {
          const requestOptions = {
            method: "PUT",
            headers: {
              "Content-Type": file.type,
            },
            body: file,
          };
          const uploadResponse = await fetch(
            UrlResponse.payload[0].image_url,
            requestOptions
          );
          if (uploadResponse.status === 200) {
            try {
              const response = await uploadFiles(
                request.id,
                UrlResponse.payload[0].image_key
              );
              if (response.payload.imgae_url) {
                setPreviewImage(response.payload.image_url);
              }
              setSelectedFile(file);
              setUploading(false);
              return;
            } catch (error) {
              console.error("Error uploading photo:", error);
              setError("Profile upload failed. Please try again later.");
              setUploading(false);
              return;
            }
          } else {
            console.error("Failed to upload photo:", uploadResponse.statusText);
            setError("Profile upload failed. Please try again later.");
            setUploading(false);
            return;
          }
        } catch (error) {
          console.error("Error uploading image:", error);
          setError("Image upload failed. Please try again later");
          setUploading(false);
        }
        return;
      } else {
        setError("Image upload failed. Please try again later");
        setUploading(false);
        return;
      }
    } catch (error) {
      console.error("Error uploading URL:", error);
      setError("Image upload failed. Please try again later");
      setUploading(false);
    }
  };

  const handleRejectOrDelete = async () => {
    try {
      if (request?.relation_status === "pending") {
        await denyRequest(request.id);
        onReject?.(request.id);
      } else {
        await deleteRelationship(request.id);
        onDeleteContact?.(request.id);
      }

      if (navigateBack) {
        navigate("/myprofile");
      }
      setIsModalOpen(false);
      onBack();
    } catch (error) {
      console.error("Error rejecting/deleting relationship:", error);
    }
  };

  const renderProfileContent = () => {
    if (previewImage) {
      return (
        <div className="edit-profile-image">
          <img
            src={previewImage}
            alt={request.first_name + request.last_name}
            className="profile-picture"
            onError={(e) => {
              setPreviewImage(null);
              e.target.onerror = null;
            }}
          />
        </div>
      );
    } else if (request.firstName || request.lastName) {
      return (
        <div className="edit-profile-initials">
          {`${request?.firstName?.[0]?.toUpperCase() || ""}${
            request?.lastName?.[0]?.toUpperCase() || ""
          }` || ""}
        </div>
      );
    }
    return (
      <img
        src={defaultProfile}
        alt="default profile"
        className="default-profile"
      />
    );
  };

  const handleAcceptRelation = async () => {
    if (issending) return;

    try {
      setLoading(true);
      setIssending(true);
      // Build payload to match v2 API expectations (same shape as addRelationship)
      const relationshipData = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        relationship_type: formData.relationship_type,
        relationship_length: formData.relationship_length,
        relationship_category: formData.relationship_category,
        relationship_status: formData.relationship_status,
        relationship_goals: formData.relationship_goals || null,
        email: formData.email || null,
        nickname: formData.nickname || null,
        country_code: formData.country_code || null,
        contact: formData.contact || null,
        profile_pic_url: formData.profile_pic_url || null,
      };


      await acceptRequest(request.id, relationshipData);
      onAccept?.(request.id);
      setSuccess(true);
      // Close the dialog on success and let parent update the list via onAccept
      if (onClose) {
        onClose();
      } else {
        onBack?.();
      }
    } catch (error) {
      console.error("Error accepting the relationship request:", error);
    } finally {
      setIssending(false);
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="edit-container" style={{ width: "100%" }}>
        <div className="sendreq-close-container">
          <CloseIcon
            style={{
              cursor: "pointer",
            }}
            onClick={onClose}
          />
        </div>
        <div className="edit-profile-section">
          <div className="edit-profile-image-container">
            {renderProfileContent()}
            {/* <span
              className="edit-photo-text"
              onClick={handleImageClick}
              style={{ cursor: "pointer" }}
            >
              {uploading ? 'Uploading' : 'Edit photo'}
            </span> */}
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              disabled={uploading}
              onChange={(e) => {
                if (!uploading) {
                  handleImageChange(e);
                }
              }}
              style={{ display: "none" }}
            />
          </div>
        </div>

        <form className="edit-form">
          <div className="form-grid">
            <div className="edit-form-field">
              <label>First Name</label>
              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleInputChange}
                required
                disabled={!isEditable}
                style={{ backgroundColor: !isEditable ? "#f0f0f0" : "" }}
              />
            </div>
            <div className="edit-form-field">
              <label>Last Name</label>
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleInputChange}
                disabled={!isEditable}
                style={{ backgroundColor: !isEditable ? "#f0f0f0" : "" }}
              />
            </div>

            <div className="form-group">
              <label>Relationship Category</label>
              <select
                name="relationship_category"
                value={formData.relationship_category}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Category</option>
                {categories.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Relationship Type</label>
              <select
                name="relationship_type"
                value={formData.relationship_type}
                onChange={handleInputChange}
                disabled={!formData.relationship_category}
              >
                <option value="">Select Type</option>
                {relationTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Relationship Status</label>
              <select
                name="relationship_status"
                value={formData.relationship_status}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Status</option>
                {relationStatuses.map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </div>

            {/* <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                disabled={!isEditable}
                style={{ backgroundColor: !isEditable ? "#f0f0f0" : "" }}
              />
            </div>

            <div className="form-group-mobile">
              <div style={{ marginBottom: "6px" }}>
                <label htmlFor="" className="mobile-label-addrelation">
                  Mobile Number{" "}
                </label>
                <span className="optional">(optional)</span>
              </div>
              <PhoneInput
                id="phone-number"
                international
                defaultCountry="US"
                value={
                  formData.contact
                    ? `+${formData.country_code}${formData.contact}`
                    : ""
                }
                onChange={handlePhoneChange}
                className="addrelationship-phoneinput phone-bg"
                placeholder="Enter phone number"
                autoFocus={false}
                disabled={!isEditable}
                style={{
                  backgroundColor: !isEditable ? "#f0f0f0" : "",
                  cursor: !isEditable ? "not-allowed" : "",
                }}
              />
            </div> */}
          </div>

          {error && <p className="error-message">{error}</p>}

          <div
            style={{
              display: "flex",
              justifyContent: "left",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <button
              type="button"
              onClick={() => {
                if(!loading){
                  handleAcceptRelation();
                }
              }}
              className={`edit-person-btn ${isFormValid() && "filled"} ${loading && 'disabled'}`}
              // disabled={!isFormValid()}
            >
              {loading ? (
                <ContentLoader />
              ) : (
                <>
                  Accept Request
                  <img src={nextbtn} alt="next" className="nxtbtn" />
                </>
              )}
            </button>
          </div>
        </form>
        {
          success && (
            <div className="success-message">
              <p>Connection added successfully!</p>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default AcceptPendingRequest;
